export const services = Object.freeze({
  NODE_ENDPOINT_DASHBOARD_SIGNIN: "dashboardAuth/sign-in",
  NODE_ENDPOINT_DASHBOARD_SIGNUP: "dashboardAuth/sign-up",
});
